import { render, staticRenderFns } from "./workArea.vue?vue&type=template&id=2d83aa6c&scoped=true"
import script from "./workArea.vue?vue&type=script&lang=js"
export * from "./workArea.vue?vue&type=script&lang=js"
import style0 from "./workArea.vue?vue&type=style&index=0&id=2d83aa6c&prod&lang=less&scoped=true"
import style1 from "./workArea.vue?vue&type=style&index=1&id=2d83aa6c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83aa6c",
  null
  
)

export default component.exports